import axios from "axios";
import { authHeader } from "./headerConfig";


const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/auth";

const login = async data => {

    return await  axios.post(API_ENDPOINT + "/login", data, {
        headers: {
            Accept: "application/json",
        },
    });
};
const logout = async () => {
    return await axios.post(
        API_ENDPOINT + "/logout",
        {},
        {
            withCredentials: true,
            headers: {
                ...authHeader(),
                Accept: "application/json",
            },
        }
    );
};
const authServices = {
    login,
    logout,
};
export default authServices;
